import React, { useEffect } from 'react'
import styles from './Products.module.css'
import Categories from './Categories/Categories'
import Grid from './ListProducts/Grid'

export type ProductsProps = {
    setNavBackground: React.Dispatch<React.SetStateAction<boolean>>;
    setFilterProduct: React.Dispatch<React.SetStateAction<number | null>>;
    filterProduct: number | null;
}

const Products = (props: ProductsProps) => {

    useEffect(() => {
        props.setNavBackground(true);
    }, []);

    return (
        <div className={styles.container}>
            <Categories filterProduct={props.filterProduct} setFilterProduct={props.setFilterProduct} />
            <Grid filterProduct={props.filterProduct} setFilterProduct={props.setFilterProduct} />
        </div>
    )
}

export default Products
